import { FormGroup, FormBuilder, Validators } from '@angular/forms';

export class ClientFormBaseComponent {
  clientForm: FormGroup;
  errorMessage: string | null = null;

  constructor(protected fb: FormBuilder) {
    this.clientForm = this.fb.group({
      rut: ['', Validators.required],
      razonSocial: ['', Validators.required],
      giro: ['', Validators.required],
      direccionLegal: ['', Validators.required],
      direccionDespacho: ['', Validators.required],
    });
  }

  markAllFieldsAsTouched() {
    Object.keys(this.clientForm.controls).forEach(field => {
      const control = this.clientForm.get(field);
      control?.markAsTouched({ onlySelf: true });
    });
  }

  get rut() {
    return this.clientForm.get('rut')!;
  }
  get razonSocial() {
    return this.clientForm.get('razonSocial')!;
  }
  get giro() {
    return this.clientForm.get('giro')!;
  }
  get direccionLegal() {
    return this.clientForm.get('direccionLegal')!;
  }
  get direccionDespacho() {
    return this.clientForm.get('direccionDespacho')!;
  }
}
